import type { Key } from 'react';
import { z } from 'zod';
import type { DeepUndefinedOrNull } from '@/types/partial';
import { ProdutoFieldsSchema } from './ProdutoFields';
import { ProdutoUnidadeSchema } from './ProdutoUnidade';

/** Tipo da composição dos produtos  */
enum ProdutoComposicaoTipo {
    Kit = 1,
    Industrializacao = 2,
}

const ProdutoComposicaoProdutoSchema = ProdutoFieldsSchema.pick({
    pro_cod_barra: true,
    pro_codigo_interno: true,
    pro_custo_medio: true,
    pro_descricao: true,
    pro_permite_venda_fracionada: true,
    pro_peso_bruto: true,
    pro_peso_liquido: true,
    pro_preco_custo: true,
    pro_preco_venda: true,
    pro_produto_regra_fiscal_idpk: true,
    pro_produto_unidade_idpk: true,
    pro_sku: true,
    pro_tipo: true,
    pro_volume_qtde: true,
}).extend({
    unidade: ProdutoUnidadeSchema.pick({
        pru_descricao: true,
        pru_idpk: true,
        pru_sigla: true,
    }).nullable(),
});

export const ProdutoComposicaoSchema = z.object({
    prc_data_insercao: z.string(),
    prc_empresa_idpk: z.number(),
    prc_idpk: z.number(),
    prc_ordem: z.number(),
    prc_perda_percentual: z.number(),
    prc_produto_filho_idpk: z.number(),
    prc_produto_pai_idpk: z.number(),
    prc_quantidade: z.number(),
    prc_rateio_percentual: z.number(),
    prc_tipo: z.enum(ProdutoComposicaoTipo),
    prc_ultima_alteracao: z.string(),
    produto: ProdutoComposicaoProdutoSchema,
});

export type ProdutoComposicao = z.infer<typeof ProdutoComposicaoSchema>;

export type ProdutoComposicaoBody =
    | {
          excluir: 'S';
          key: Key;
          prc_idpk: number;
      }
    | (DeepUndefinedOrNull<ProdutoComposicao> & {
          excluir?: undefined;
          key: Key;
          totalItemKit: number | null;
      });
